import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';
export const SvgUnavailableDimension = {
  height: 20,
  width: 20,
  viewBox: '0 0 20 20',
};
export const SvgUnavailable = memo((props: SVGProps<SVGSVGElement>) => (
  <svg width={16} height={16} viewBox="0 0 16 16" fill="none" {...props}>
    <g clipPath="url(#a)">
      <mask
        id="b"
        x="0"
        y="0"
        width="16"
        height="16"
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'alpha',
        }}
      >
        <path
          fill="#EB1701"
          d="M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10"
        />
      </mask>
      <g mask="url(#b)">
        <path
          fill="#EB1701"
          d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
        />
      </g>
      <path
        fill="#fff"
        d="M8 4c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4m-3.2 4c0-1.76 1.44-3.2 3.2-3.2.72 0 1.4.24 1.96.68L5.48 9.96c-.44-.56-.68-1.24-.68-1.96M8 11.2c-.72 0-1.4-.24-1.96-.68l4.48-4.48c.44.56.68 1.24.68 1.96 0 1.76-1.44 3.2-3.2 3.2"
      />
    </g>
    <defs>
      <clipPath id="a">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
